export interface Department {
    id: number;
    name: string;
    cities: string[];
}

export const COLOMBIA_DATA: Department[] = [
    {
        id: 0,
        name: "Amazonas",
        cities: ["Leticia", "Puerto Nariño"]
    },
    {
        id: 1,
        name: "Antioquia",
        cities: ["Medellín", "Bello", "Itagüí", "Envigado", "Apartadó", "Rionegro", "Turbo", "Caucasia"]
    },
    {
        id: 2,
        name: "Arauca",
        cities: ["Arauca", "Arauquita", "Saravena", "Tame"]
    },
    {
        id: 3,
        name: "Atlántico",
        cities: ["Barranquilla", "Soledad", "Malambo", "Sabanalarga", "Baranoa"]
    },
    {
        id: 4,
        name: "Bolívar",
        cities: ["Cartagena", "Magangué", "Turbaco", "El Carmen de Bolívar", "Arjona"]
    },
    {
        id: 5,
        name: "Boyacá",
        cities: ["Tunja", "Duitama", "Sogamoso", "Chiquinquirá", "Puerto Boyacá"]
    },
    {
        id: 6,
        name: "Caldas",
        cities: ["Manizales", "La Dorada", "Chinchiná", "Villamaría", "Riosucio"]
    },
    {
        id: 7,
        name: "Caquetá",
        cities: ["Florencia", "San Vicente del Caguán"]
    },
    {
        id: 8,
        name: "Casanare",
        cities: ["Yopal", "Aguazul", "Villanueva"]
    },
    {
        id: 9,
        name: "Cauca",
        cities: ["Popayán", "Santander de Quilichao", "Puerto Tejada"]
    },
    {
        id: 10,
        name: "Cesar",
        cities: ["Valledupar", "Aguachica", "Codazzi"]
    },
    {
        id: 11,
        name: "Chocó",
        cities: ["Quibdó", "Istmina"]
    },
    {
        id: 12,
        name: "Córdoba",
        cities: ["Montería", "Lorica", "Sahagún", "Cereté", "Montelíbano"]
    },
    {
        id: 13,
        name: "Cundinamarca",
        cities: ["Bogotá", "Soacha", "Fusagasugá", "Facatativá", "Zipaquirá", "Chía", "Girardot", "Mosquera", "Madrid", "Funza", "Cajicá"]
    },
    {
        id: 14,
        name: "Guainía",
        cities: ["Inírida"]
    },
    {
        id: 15,
        name: "Guaviare",
        cities: ["San José del Guaviare"]
    },
    {
        id: 16,
        name: "Huila",
        cities: ["Neiva", "Pitalito", "Garzón", "La Plata"]
    },
    {
        id: 17,
        name: "La Guajira",
        cities: ["Riohacha", "Maicao", "Uribia", "Manaure", "San Juan del Cesar", "Barrancas", "Fonseca"]
    },
    {
        id: 18,
        name: "Magdalena",
        cities: ["Santa Marta", "Ciénaga", "Zona Bananera", "Plato", "Fundación"]
    },
    {
        id: 19,
        name: "Meta",
        cities: ["Villavicencio", "Acacías", "Granada"]
    },
    {
        id: 20,
        name: "Nariño",
        cities: ["Pasto", "Tumaco", "Ipiales"]
    },
    {
        id: 21,
        name: "Norte de Santander",
        cities: ["Cúcuta", "Ocaña", "Villa del Rosario", "Los Patios"]
    },
    {
        id: 22,
        name: "Putumayo",
        cities: ["Mocoa", "Puerto Asís"]
    },
    {
        id: 23,
        name: "Quindío",
        cities: ["Armenia", "Calarcá", "La Tebaida", "Circasia", "Montenegro"]
    },
    {
        id: 24,
        name: "Risaralda",
        cities: ["Pereira", "Dosquebradas", "Santa Rosa de Cabal"]
    },
    {
        id: 25,
        name: "San Andrés y Providencia",
        cities: ["San Andrés", "Providencia"]
    },
    {
        id: 26,
        name: "Santander",
        cities: ["Bucaramanga", "Floridablanca", "Barrancabermeja", "Girón", "Piedecuesta", "San Gil"]
    },
    {
        id: 27,
        name: "Sucre",
        cities: ["Sincelejo", "Corozal", "San Marcos"]
    },
    {
        id: 28,
        name: "Tolima",
        cities: ["Ibagué", "Espinal", "Melgar", "Chaparral", "Líbano"]
    },
    {
        id: 29,
        name: "Valle del Cauca",
        cities: ["Cali", "Buenaventura", "Palmira", "Tulua", "Yumbo", "Cartago", "Jamundí", "Buga"]
    },
    {
        id: 30,
        name: "Vaupés",
        cities: ["Mitú"]
    },
    {
        id: 31,
        name: "Vichada",
        cities: ["Puerto Carreño"]
    }
];
